var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"professional__owl-carousel_card",style:({
            'background-image': ("linear-gradient( 358.23deg, #000000 3.46%, rgba(0, 0, 0, 0) 46.91%), url(" + (_vm.item.avatar) + ")"),
            width: '30%',
            display: 'inline-block'
        })},[_c('p',{staticClass:"professional__owl-carousel_card-name"},[_vm._v(_vm._s(_vm.item.fullName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }